var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92415 7.97634V14.1665H8.07648V7.97634L14.8857 7.97634V6.92877L8.07648 6.92877V0.833832L6.92415 0.833832V6.92877L0.219727 6.92877V7.97634L6.92415 7.97634Z",
    fill: "#ABB8C5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plusSign.5a656f2147951aad586edfb9a52ba9d6.svg";